export enum PAY_AMOUNT {
  FULL = 2,
  DEPOSIT = 1,
}

export enum PAYMENT_METHOD {
  CASH = 1,
  MOMO = 3,
  TRANSFER = 4,
  ONLINE = 2,
  VISA_MASTER = 21,
  ATM = 22,
  QR = 24,
}

export enum PAYMENT_ONLINE_METHOD {
  VISA_MASTER = 1,
  ATM = 2,
  QR = 4,
}

export enum PAYMENT_STATUS {
  SUCCESS = 'success',
  FAILED = 'failed',
  PENDING = 'pending',
}

export default interface PaymentMethodInfo {
  paymentUrl: string;
  paymentMethod: number;
  paymentOnlineOption: number | null;
  amountType: number | null;
}
